import { StaleTime, useQuery } from "@tanstack/react-query";
import { ListResponse } from "../utils/SharedAPI";
import { Insurance } from "../models/insurance";
import { API } from "../utils/Api";


export function useInsuranceQuery(clientId:string, patientId:string, enabled = true,
    staleTime:StaleTime<ListResponse<Insurance>, Error, ListResponse<Insurance>, string[]> | undefined = 5_000) {
    return useQuery({
        queryKey: ['patient.insurance.list', clientId, patientId],
        queryFn: async () => {
            return await API.getInsuranceList(clientId, patientId);
        },
        select: (data) => { return data?.items  },
        staleTime:staleTime,
        enabled:enabled
    })
}